import React from "react";
import { Button, ButtonProps } from "@mui/material";

// A delete/clear button outside a grid: a white button with red text. The destructive counterpart of
// ActionButton, for removing or clearing something in a normal button row. In a grid, use the round
// DeleteIconButton instead. Callers supply the label (and an optional startIcon).
const DeleteButton = ({ children, ...props }: ButtonProps) => (
  <Button variant="outlined" color="error" {...props}>
    {children}
  </Button>
);

export default DeleteButton;
